import { NgClass } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'app-collapse-filter',
	templateUrl: './collapse-filter.component.html',
	styleUrls: ['./collapse-filter.component.scss'],
	imports: [NgClass]
})
export class CollapseFilterComponent {
	@Output() collapse = new EventEmitter<boolean>();

	public collapsed = false;
	public toggle() {
		this.collapsed = !this.collapsed;
		this.collapse.emit(this.collapsed);
	}
}
